export default __webpack_public_path__ + "d36fa3e505a99ce7ef10b1b762e29971.svg";